import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42a04e7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"0"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Geen bouwnummers gevonden.", -1))

import { authStore } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'
import { ls } from '@/ls'
import { computed, onMounted, ref } from 'vue'
import { HomeFilled, LoadingOutlined } from '@ant-design/icons-vue'
import axios from 'axios'
import { headerStore } from '@/stores/header'
import { permissions } from '@/globalVariables'
import ProjectRelatedBuildingSelector from '@/views/buildingselection/ProjectRelatedBuildingSelector.vue'

interface Building {
  id:number
  number:number
  address:string|null
  zipcode:string|null
  city:string|null
  is_demo:boolean
  project:{ id:number, reference:string, name:string }
  projectReference:string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingSelector',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref<number|boolean>(false)
const searchTerm = ref('')
const buildingCount = computed(() => ls.get('buildings').length)
const auth = authStore()

const projectsWithBuildings = computed(() => {
  if (searchTerm.value.length) {
    const st = searchTerm.value.toLowerCase()
    const filteredBuildings = ls.get('buildings').filter((b:{ number:number, address:string|null, zipcode:string|null, city:string|null, project:string|null }) => {
      return b.number.toString().includes(st) ||
        (b.address ? b.address.toLowerCase().includes(st) : false) ||
        (b.zipcode ? b.zipcode.toLowerCase().includes(st) : false) ||
        (b.city ? b.city.toLowerCase().includes(st) : false) ||
        (b.project ? b.project.toLowerCase().includes(st) : false)
    })

    return groupBuildingsByProject(filteredBuildings)
  }
  return groupBuildingsByProject(ls.get('buildings'))
})

function groupBuildingsByProject (buildings: Building[]): { name: string, buildings: Building[] }[] {
  const projectMap = new Map<string, { name: string, buildings: Building[] }>()

  buildings.forEach(building => {
    const projectName = building.project.name
    if (!projectMap.has(projectName)) {
      projectMap.set(projectName, { name: projectName, buildings: [] })
    }
    const projectEntry = projectMap.get(projectName)
    if (projectEntry) {
      projectEntry.buildings.push(building)
    }
  })

  const projectArray = Array.from(projectMap.values())
  projectArray.sort((a, b) => a.name.localeCompare(b.name))
  return projectArray
}

onMounted(() => {
  headerStore().resetOrdersReceived()
  headerStore().disableExtraPhase()
  headerStore().disableService()
})

function selectBuilding (building:{ id:number, number:number, oldProjectReference:string, projectReference:string }) : void {
  loading.value = building.id
  axios.post(process.env.VUE_APP_API_URL + '/building/set', { bid: building.id }).then((r) => {
    authStore().setIsInternalDemoAccount(building.projectReference + '@woonon.nl')
    authStore().setIsDemoCustomer(r.data.demo)
    authStore().setCurrentBuilding(r.data as Building)
    headerStore().getOrdersReceived()
    headerStore().checkIfExtraPhaseIsEnabled()
    headerStore().checkIfServiceIsEnabled()

    if (route.query.redirect && typeof route.query.redirect === 'string') {
      router.push({ path: route.query.redirect })
    } else {
      router.push({ name: 'Dashboard' })
    }
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_unref(auth).hasPermission(_unref(permissions).VIEW_DEMO_BUILDINGS) || _unref(auth).hasPermission(_unref(permissions).VIEW_SOLD_BUILDINGS))
    ? (_openBlock(), _createBlock(_component_a_row, {
        key: 0,
        gutter: [16,16]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(ProjectRelatedBuildingSelector)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_a_row, {
        key: 1,
        gutter: [16,16]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, {
                title: "Kies een bouwnummer.",
                bordered: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, "Hallo " + _toDisplayString(_unref(authStore)().user.firstname) + " " + _toDisplayString(_unref(authStore)().user.lastname) + ",", 1),
                          _createElementVNode("p", _hoisted_1, "We zien dat er " + _toDisplayString(_unref(buildingCount)) + " bouwnummers aan uw account zijn gekoppeld. Op welk bouwnummer wilt u inloggen?", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_divider),
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 8}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            placeholder: "Zoek op bouwnummer, adres of project..",
                            value: searchTerm.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_divider),
                  _createVNode(_component_a_row, {
                    gutter: 16,
                    style: {"margin-bottom":"24px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(HomeFilled), { style: { fontSize: '18px', color: '#f38929', marginRight: '4px' } }),
                          _createTextVNode(" Uw bouwnummers "),
                          _createVNode(_unref(HomeFilled), { style: { fontSize: '18px', color: '#333', marginLeft: '16px', marginRight: '4px' } }),
                          _createTextVNode(" Demo's ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_divider),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectsWithBuildings), (p) => {
                    return (_openBlock(), _createBlock(_component_a_row, {
                      gutter: [16,16],
                      key: p.name,
                      style: { marginBottom: '24px' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", null, _toDisplayString(p.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.buildings, (b) => {
                          return (_openBlock(), _createBlock(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8},
                            key: b.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                class: "config-card",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (selectBuilding(b))
                              }, {
                                actions: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    (loading.value === b.id)
                                      ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                                          key: 0,
                                          style: {"margin-right":"8px"}
                                        }))
                                      : _createCommentVNode("", true),
                                    _createTextVNode("Selecteer bouwnummer")
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_card_meta, {
                                    title: `Bouwnummer ${b.number}`
                                  }, {
                                    avatar: _withCtx(() => [
                                      _createVNode(_unref(HomeFilled), {
                                        style: _normalizeStyle({ fontSize: '22px', color: b.is_demo ? '#333' : '#f38929' })
                                      }, null, 8, ["style"])
                                    ]),
                                    description: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(b.address && b.zipcode && b.city ? `${b.address}, ${b.zipcode} ${b.city}` : 'Adres (nog) niet bekend.'), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (!_unref(projectsWithBuildings).length)
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 0,
                        gutter: 16
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})